// Shared browser-direct R2 upload mechanics, used by BOTH the new-meeting
// form and the replace-audio flow on failed meetings (spec 2026-07-14 §2:
// one implementation, two callers). The signed URL itself comes from
// getUploadUrl in ./api.
import { t, tVars } from "../i18n";

export function isMediaFile(file: File): boolean {
  return file.type.startsWith("audio/") || file.type.startsWith("video/");
}

export function putWithProgress(
  url: string,
  headers: Record<string, string>,
  file: File,
  onProgress: (pct: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    Object.entries(headers).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(tVars("upload.r2UploadFailed", { status: xhr.status, text: xhr.responseText })));
    };
    xhr.onerror = () => reject(new Error(t("upload.r2NetworkError")));
    xhr.send(file);
  });
}
